import React from "react";
import { Box, Dialog, DialogContent } from "@mui/material";

const MessageDialog = (props) => {
  const { children, showPopUp, maxContentWidth } = props;
  return (
    <Box>
      <Dialog open={showPopUp} className="app-dialog">
        <DialogContent sx={{ padding: "40px", maxWidth: maxContentWidth || "500px" }}>
          <Box
            component="div"
            sx={{
              textAlign: "center",
            }}
          >
            {children}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default MessageDialog;
